module.exports = __webpack_public_path__ + "static/media/tron_uprising.a87963f5.jpg";